import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineLogin } from "react-icons/ai";
import "./loginstyle.css";
import "./Login2.css";
import { RotatingLines } from "react-loader-spinner";
import { CiUser } from "react-icons/ci";
import { CiLock } from "react-icons/ci";
import leftImg from "./images/login-image.png";
import blob2 from "./images/blob2.svg";
import axios from "axios";
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import ic_strike from "./images/strike.svg";
import ic_blob_1 from "./images/ic_blob_1.png";
import ic_blob_2 from "./images/ic_blob_2.png";
import ic_blob_3 from "./images/ic_blob_3.png";
import logo from "./images/appLogoCrop.png";
import cbxlogo from "./images/product1.png";
import hrBG from "./images/hrBG1.svg";

const Login = () => {
  const [data, setData] = useState(null);
  const [exData, setExData] = useState(null);

  const [cmpcode, setCmpCode] = useState("");
  const [publick, setpublick] = useState("");
  const [privatek, setprivatek] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showReregisterModal, setShowReregisterModal] = useState(false);

  const handleClear = () => {
    localStorage.clear();
    window.location.reload();
  };

  const [userData, setUserData] = useState({
    username: "",
    password: "",
  });

  const [loginError, setLoginError] = useState(null);

  const [loginClick, setLoginClick] = useState(false);

  const [portNoData, setPortNoData] = useState("");

  const [userDataArrayState, setUserDataArrayState] = useState(null);

  const navigate = useNavigate();

  const LoginuserData = JSON.parse(
    localStorage.getItem("BondTimeLoginUserData"),
  );

  // Check if user is logged in and has "Success" status
  const isAuthenticated =
    LoginuserData && LoginuserData[0]?.Userlogin === "Sucess";

  useEffect(() => {
    if (isAuthenticated) {
      //  navigate('/admin/home')
    }
  }, [isAuthenticated]);

  const handleTogglePassword = () => {
    console.log("psswdToggleClick");
    setShowPassword((prevState) => !prevState);
  };

  const handleGetPortNo = async () => {
    try {
      const response = await axios.get(
        `https://cubixweberp.com:301/api/clientmanager/${userDataArray[0].cmpcode}`,
      );
      if (response.status === 200) {
        setPortNoData(response.data);
        console.log("response.data::", response.data);
        localStorage.setItem(
          "BondTimeportNoData",
          JSON.stringify(response.data),
        );
      }
    } catch (error) {
      console.log("handleGetPortNo", error);
    }
  };

  useEffect(() => {
    // Retrieve the selected company details from local storage
    const selectedCompanyString = localStorage.getItem(
      "BondTimeselectedCompany",
    );

    // Check if a selected company is stored in local storage
    if (selectedCompanyString) {
      const selectedCompany = JSON.parse(selectedCompanyString);

      // Access the company details and set them as states
      setCmpCode(selectedCompany.cmpcode);
      setpublick(selectedCompany.publick);
      setprivatek(selectedCompany.privatek);
    } else {
      // Handle the case where no selected company is found
      console.error("No selected company found in local storage");
    }
  }, []);

  // console.log(cmpcode, publick, privatek)

  useEffect(() => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

    if (storedUserDataArray.length === 0) {
      // setDeviceValidation('INVALID')
      navigate("/");
      console.log("not validated");
    }
  }, []);

  const user = localStorage.getItem("User");

  // console.log(user)

  // useEffect(() => {
  //   // Check if the user is already logged in (e.g., 'User' key exists in localStorage)
  //   const isLoggedIn = localStorage.getItem('User') !== null;
  //   console.log(isLoggedIn)
  //   // If user is already logged in, redirect to admin/dashboard
  //   if (isLoggedIn) {
  //     navigate('/admin/dashboard');
  //   }
  // }, [navigate]);

  const userDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  // Find the index of the selected company in userDataArray (assuming cmpcode is unique)
  const selectedCompany = userDataArray.find(
    (company) => company.cmpcode === cmpcode,
  );

  if (selectedCompany && selectedCompany.User) {
    console.log(selectedCompany, selectedCompany.User);

    toast.success(`Welcome ${selectedCompany.User}`, {
      autoClose: 1500,
    });
    // User is logged in, redirect to dashboard
    // navigate('/admin/home');
  }

  // console.log(selectedCompany)

  // useEffect(() => {

  //   console.log(selectedCompany, 'from useEffect')
  //   if (selectedCompany && selectedCompany.User && selectedCompany.User.trim() !== "") {

  //     toast.success(`Welcome ${selectedCompany.User}`, {
  //       autoClose: 1500
  //     })
  //     // User is logged in, redirect to dashboard
  //     navigate('/admin/dashboard');
  //   }
  // }, [selectedCompany]);

  const handleInputChange = (e) => {
    // console.log(e.target.value)
    const { name, value } = e.target;
    setUserData({
      ...userData,
      [name]: value,
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (userData.username && userData.password) {
      setLoginClick(true);
      setUserData({
        username: "",
        password: "",
      });

      const url = `${portNoData[0].API_CONFIG}/api/LoginUser?user=${userData.username}&pass=${userData.password}&cmpcode=${cmpcode}`;

      console.log("API URL login", url);

      axios
        .get(url)
        .then((response) => {
          // Handle the response data here
          const loginResponse = response.data[0];
          console.log("Login Response:", loginResponse.Userlogin);

          if (loginResponse.Userlogin !== "Sucess") {
            setLoginError("Invalid Username or Password");
            setLoginClick(false);
          } else {
            // Save response data in localStorage
            console.log("login user data", response.data);
            localStorage.setItem(
              "BondTimeLoginUserData",
              JSON.stringify(response.data),
            );

            // Set a login flag in localStorage
            localStorage.setItem("isFreshLogin", "true");
            // Navigate to the admin home page
            navigate("/admin/home");
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoginError("Some Error Occurred");
          setLoginClick(false);
        });
    } else {
      setLoginError("Please enter both username and password");
    }
  };

  const fetchData = async () => {
    try {
      const storedUserDataArray = localStorage.getItem("BondTimeuserDataArray");
      const parsedUserDataArray = JSON.parse(storedUserDataArray) || [];

      setUserDataArrayState(parsedUserDataArray);

      // let apiUrl = `https://cubixweberp.com:${parsedUserDataArray[0].portNo}/api/`

      // await AsyncStorage.setItem('appUrl', apiUrl)

      if (parsedUserDataArray.length === 0) {
        // setDeviceValidation('INVALID')
        navigate("/");
        console.log("not validated");
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (userDataArrayState) {
      handleGetPortNo();
    }
  }, [userDataArrayState]);

  // useEffect(() => {
  //   if (exData !== null) {
  //     if (exData.UserList[0].User) {
  //       // console.log(exData.UserList[0])
  //       toast.success(`Welcome ${exData.UserList[0].User}`, {
  //         autoClose: 1500
  //       })
  //       navigate('/admin/dashboard')
  //     }
  //   }
  // }, [exData])

  // console.log(apiData[0].UserInfo.UserList)

  // console.log(data)
  // console.log(exData && exData)
  // console.log(exData && exData.UserList[0].User)
  // console.log(data && typeof (data))
  // console.log(userData.username, userData.password)

  console.log("portNoData", portNoData);

  return (
    <>
    <div class="login-fg" style={{ height: "100vh", overflowY: "scroll" }}>


      <div className="flex h-screen overflow-y-auto font-sans">
        <div className="relative flex-1  md:flex flex-col justify-center items-start px-14 py-16 bg-gradient-to-br from-[#1a4fd6] via-[#2663EB] to-[#1e90c8] overflow-hidden">
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-white/5" />
          <div className="absolute -bottom-24 -left-14 w-72 h-72 rounded-full bg-white/[0.04]" />
          <div className="flex justify-between items-centre">
            <div>
              {/* <div className="flex items-center gap-3 mb-12">
            <div className="w-11 h-11 bg-white rounded-xl flex items-center justify-center">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                  stroke="#2663EB"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span className="text-xl font-bold text-white tracking-wide">
              BONDTIME HR
            </span>
          </div> */}

              <h1 className="text-4xl font-extrabold text-white leading-tight mb-4">
                Manage your
                <br />
                workforce smarter
              </h1>
              <p className="text-[15px] text-white/70 leading-relaxed max-w-sm">
                A complete HR platform for payroll, attendance, leave
                management, and employee records — all in one place.
              </p>

              <div className="flex flex-col gap-3 mt-10">
                {[
                  "Employee registration & profiles",
                  "Payroll processing & WPS",
                  "Leave & attendance management",
                  "Fleet & end-of-service tracking",
                ].map((f) => (
                  <div key={f} className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-white/50 flex-shrink-0" />
                    <span className="text-[13px] text-white/75">{f}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img src={hrBG} alt="" />
            </div>
          </div>
        </div>

        <div className="relative w-full md:w-[40%] flex-shrink-0 bg-[#F9FAFA] flex flex-col justify-center items-center px-6 py-12">
          <img
            src={cbxlogo}
            alt="cubixLogo"
            className="absolute top-2 right-2 h-6 "
          />
          <button
            onClick={() => setShowReregisterModal(true)}
            className="absolute top-2 left-2 text-[11px] font-semibold text-[#2663EB] bg-[#EFF4FF] px-3 py-1 rounded-full hover:bg-[#2663EB] hover:text-white transition-all duration-200 cursor-pointer"
          >
            Re-register
          </button>

          <div className="w-full max-w-[420px]">
            <img
              // className=" w-[43%] object-cover overflow-hidden"
              className="mt-2 w-[160px]  object-fit overflow-hidden mb-6"
              src={logo}
              alt=""
              onClick={() => navigate("/admin/home")}
            />
            {/* <span className="text-[12px] font-semibold text-[#2663EB] bg-[#EFF4FF] px-3 py-1 rounded-full inline-block mb-6 tracking-wider">
            BONDTIME SIGN IN
          </span> */}

            <h2 className="text-[26px] font-extrabold text-gray-900 mb-1">
              Welcome back
            </h2>
            <p className="text-sm text-slate-500 mt-4 mb-8">
              Sign in to your
              <span className="mx-1 text-slate-900 font-semibold">{portNoData[0]?.COMPNAME}</span>
              account to continue
            </p>
            <div className="mb-4">
              <label className="block text-[12px] font-semibold text-gray-500 mb-1.5 tracking-wider">
                USERNAME
              </label>
              <input
                type="text"
                name="username"
                value={userData.username}
                onChange={handleInputChange}
                placeholder="Enter your username"
                className="w-full px-4 py-[13px] rounded-[14px] border-[1.5px] border-[#e8ecf4] bg-white text-sm text-gray-800 placeholder:text-gray-300 outline-none focus:border-[#2663EB] focus:ring-2 focus:ring-[#2663EB]/10 transition-all"
              />
            </div>

            <div className="mb-2">
              <label className="block text-[12px] font-semibold text-gray-500 mb-1.5 tracking-wider">
                PASSWORD
              </label>
              <div className="flex justify-between items-center gap-2">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={userData.password}
                  onChange={handleInputChange}
                  placeholder="Enter your password"
                  className="w-full px-4 py-[13px] rounded-[14px] border-[1.5px] border-[#e8ecf4] bg-white text-sm text-gray-800 placeholder:text-gray-300 outline-none focus:border-[#2663EB] focus:ring-2 focus:ring-[#2663EB]/10 transition-all"
                />
                {showPassword ? (
                  <i id="eyePass" onClick={handleTogglePassword}>
                    <FaRegEye className="text-gray-400" />
                  </i>
                ) : (
                  <i id="eyePass" onClick={handleTogglePassword}>
                    <FaRegEyeSlash className="text-gray-400" />
                  </i>
                )}
              </div>
            </div>

            {/* <div className="text-right mb-6">
            <a href="#" className="text-xs text-[#2663EB] hover:underline">
              Forgot password?
            </a>
          </div> */}

            {!loginClick ? (
              <button
                // className="btn-Login"
                onClick={(e) => handleLogin(e)}
                className="mt-6 w-full py-[14px] bg-gradient-to-r from-[#2663EB] to-[#1e90c8] text-white font-bold text-[15px] rounded-[14px] shadow-lg hover:-translate-y-0.5 hover:shadow-[0_12px_24px_rgba(38,99,235,0.35)] active:scale-[0.98] transition-all duration-200"
              >
                {/* <AiOutlineLogin /> */}
                &nbsp;Sign in
              </button>
            ) : (
              <RotatingLines
                strokeColor="blue"
                strokeWidth="5"
                animationDuration="0.75"
                width="40"
                visible={true}
              />
            )}
            {/* <button className="mt-6 w-full py-[14px] bg-gradient-to-r from-[#2663EB] to-[#1e90c8] text-white font-bold text-[15px] rounded-[14px] shadow-[0_8px_20px_rgba(38,99,235,0.3)] hover:-translate-y-0.5 hover:shadow-[0_12px_24px_rgba(38,99,235,0.35)] active:scale-[0.98] transition-all duration-200">
              Sign In
            </button> */}

            <div className="flex items-center gap-3 mb-6 mt-12 text-xs text-gray-300">
              <div className="flex-1 h-px bg-[#e8ecf4]" />
              <p className="text-center text-[11px] text-gray-400">
                Developed by{" "}
                <a
                  href="https://cubixitsolutions.com/"
                  target="_blank"
                  className="text-[#2663EB] hover:underline"
                >
                  Cubix IT Solutions LLC
                </a>
              </p>
              <div className="flex-1 h-px bg-[#e8ecf4]" />
            </div>
          </div>
        </div>
      </div>
    </div>
   

    {showReregisterModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="bg-white rounded-2xl shadow-xl p-6 w-[340px] text-center">
          <h3 className="text-lg font-bold text-gray-900 mb-2">Re-register?</h3>
          <p className="text-sm text-gray-500 mb-6">
            This will clear all saved data and you'll need to register your device again. Do you want to continue?
          </p>
          <div className="flex gap-3 justify-center">
            <button
              onClick={() => setShowReregisterModal(false)}
              className="px-5 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all"
            >
              No
            </button>
            <button
              onClick={handleClear}
              className="px-5 py-2 text-sm font-semibold text-white bg-[#2663EB] rounded-lg hover:bg-[#1e50c0] transition-all"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    )}

    </>
  );
};

export default Login;



// old Login screen jsx 


//  <div class="container-fluid" style={{ height: "100%" }}>
//         <div class="row" style={{ height: "100%" }}>
//           <div
//             className="col-lg-6 col-md-6 col-sm-12"
//             style={{
//               // backgroundImage: "url('https://images.unsplash.com/photo-1538475711279-0373b6bc754e?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=ad852715b5223db487fe48eef21df4ce&auto=format&fit=crop&w=1308&q=80')",
//               // backgroundSize: 'cover',
//               backgroundColor: "#E4DFD7",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center", // Vertically center the content
//               // justifyContent: 'space-evenly',
//             }}
//             id="imgContLogin"
//           >
//             <div class="info">
//               <h2 style={{ color: "#000000" }}>
//                 All in one HR Management Solutions
//               </h2>
//               <img src={ic_strike} />
//             </div>
//             <div
//               style={{ position: "relative", height: "100%", width: "100%" }}
//             >
//               <img
//                 src={ic_blob_1}
//                 alt=""
//                 style={{
//                   position: "absolute",
//                   top: "50%",
//                   left: "50%",
//                   transform: "translate(-50%, -100%)",
//                   width: "40%",
//                   objectFit: "contain",
//                 }}
//               />
//               <img
//                 src={ic_blob_2}
//                 alt=""
//                 style={{
//                   position: "absolute",
//                   top: "50%",
//                   left: "50%",
//                   transform: "translate(0%, -30%)",
//                   width: "38%",
//                   objectFit: "contain",
//                 }}
//               />
//               <img
//                 src={ic_blob_3}
//                 alt=""
//                 style={{
//                   position: "absolute",
//                   top: "50%",
//                   left: "50%",
//                   transform: "translate(-100%, 10%)",
//                   width: "38%",
//                   objectFit: "contain",
//                 }}
//               />
//             </div>
//           </div>
//           <div
//             className="col-lg-6 col-md-6 col-sm-12"
//             style={{
//               display: "flex",
//               alignItems: "center", // Vertically center the content
//               justifyContent: "center",
//               backgroundColor: "white",
//               // Horizontally center the content
//             }}
//             // class="col-xl-4 col-lg-5 col-md-12 login"
//             id="LoginCont"
//           >
//             <div class="login-section">
//               {/* <div style={{ display: "flex", justifyContent: "center" }}>
//                 <div style={{ width: "50%", cursor: "pointer" }} onClick={() => navigate('/')}>
//                   <span><IoPlayBackCircle /></span><span>Select Company</span>
//                 </div>
//               </div> */}
//               <div class="logo clearfix">
//                 <h2>Login</h2>
//                 {cmpcode && publick && privatek ? (
//                   <div style={{ color: "green", fontSize: "18px" }}>
//                     Machine Validated
//                   </div>
//                 ) : (
//                   ""
//                 )}
//                 {/* {
//                   isDeviceValidated === 'VALIDATED' ? <div style={{ color: 'green' }}>Machine Validated</div> : ""
//                 } */}
//                 <h6 style={{ color: "red" }}>{loginError}</h6>
//                 <h4
//                   style={{
//                     color: "orange",
//                     fontSize: "15px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Company Code:{"  "}
//                   {cmpcode}
//                 </h4>
//               </div>

//               <div class="form-container mt-4">
//                 <form>
//                   <div class="form-group form-fg">
//                     <i>
//                       <CiUser />
//                     </i>
//                     <input
//                       type="text"
//                       name="username"
//                       value={userData.username}
//                       onChange={handleInputChange}
//                       placeholder="Enter Username"
//                       class="input-text"
//                     />
//                   </div>
//                   <div class="form-group form-fg">
//                     <i>
//                       <CiLock />
//                     </i>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       name="password"
//                       value={userData.password}
//                       onChange={handleInputChange}
//                       placeholder="Enter Password"
//                       class="input-text"
//                     />
//                     {/* <i class="fa fa-unlock-alt"></i> */}
//                     <i className="fa fa-unlock-alt"></i>
//                     {showPassword ? (
//                       <i id="eyePass" onClick={handleTogglePassword}>
//                         <FaRegEye />
//                       </i>
//                     ) : (
//                       <i id="eyePass" onClick={handleTogglePassword}>
//                         <FaRegEyeSlash />
//                       </i>
//                     )}
//                   </div>
//                   <div class="form-group mt-2">
//                     {/* <button className="btn-Login">Login</button> */}
//                     {!loginClick ? (
//                       <button
//                         className="btn-Login"
//                         onClick={(e) => handleLogin(e)}
//                       >
//                         <AiOutlineLogin />
//                         &nbsp;Login
//                       </button>
//                     ) : (
//                       <RotatingLines
//                         strokeColor="green"
//                         strokeWidth="5"
//                         animationDuration="0.75"
//                         width="40"
//                         visible={true}
//                       />
//                     )}
//                   </div>
//                 </form>
//               </div>
//               <p className="cbx-bot-bann">
//                 Cubix Dashboard, Developed by Cubix IT Solutions LLC
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
